import {ApiErrors} from '../../../constants/apiErrors';

export const LoginApiErrors: Record<string, string> = {
  [ApiErrors.invalid_email_or_password]: 'Uh oh... Email or password don\'t look right.',
  [ApiErrors.invalid_request_body]: 'invalid_request_body'
};
